import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
    Box,
    DaTable,
    DaTableBody,
    DaTableHeadCell,
    DaTableHead,
    Text,
} from '@paygreen/paygreen-ui';
import MemoizedRow from './MemoizedRow';

const MatchingDaTable = ({
    t,
    data,
    isLoading,
    headerGroups,
    page,
    prepareRow,
    selectedRowIds,
    setModalData,
}) => (
    <Box>
        <DaTable
            blockWidth="none"
            isLoading={isLoading}
            loadingRowNumber={15}
            loadingMainCellNumber={3}
        >
            {headerGroups.map((headerGroup) => (
                <DaTableHead
                    blockTitle={t('user.list.table.title')}
                    {...headerGroup.getHeaderGroupProps()}
                >
                    {headerGroup.headers.map((column, index) => (
                        <DaTableHeadCell
                            key={index}
                            isCheckbox={index === 0}
                            label={
                                index === 0
                                    ? t('user.list.table.checkbox')
                                    : column.render('Header')
                            }
                        >
                            {/* to render checkbox as a child cell in first column */}
                            {index === 0 && column.render('Header')}

                            {index === 2 || index === 5
                                ? column.render('Filter')
                                : null}
                        </DaTableHeadCell>
                    ))}
                </DaTableHead>
            ))}

            <DaTableBody>
                {!isLoading && data.length && page.length ? (
                    page.map((row) => {
                        prepareRow(row);

                        const isActive = Object.keys(selectedRowIds).includes(
                            row.id,
                        );

                        return (
                            <MemoizedRow
                                key={row.id}
                                row={row}
                                data={data}
                                setModalData={setModalData}
                                className="DaTableRow"
                                isActive={isActive}
                                {...row.getRowProps()}
                            />
                        );
                    })
                ) : (
                    <Text
                        align="center"
                        marginTop="xl"
                        marginBottom="xl"
                        textSize="sm"
                    >
                        {t('noDataFound')}
                    </Text>
                )}
            </DaTableBody>
        </DaTable>
    </Box>
);

MatchingDaTable.propTypes = {
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
    headerGroups: PropTypes.array.isRequired,
    page: PropTypes.array.isRequired,
    prepareRow: PropTypes.func.isRequired,
    selectedRowIds: PropTypes.object,
    handleRefreshData: PropTypes.func,
    setModalData: PropTypes.func,
};

MatchingDaTable.defaultProps = {
    isLoading: false,
};

export default withTranslation('common')(MatchingDaTable);
